// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f0342946","952":"571c4582"}[chunkId] + ".chunk.js";
};